// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__64fg8","content":"Player_content__3S3oF","close":"Player_close__1B-XI"};